const accentsConfig = {
  black: "#110F15", // deprecated
  green: "#167439",
  red: "#A4262C",
  "electric-blue": "#1D00CF",
  "dusty-blue": "#40587C",
  "muted-blue": "#4052AB",
  "muted-green": "#407855",
  orange: "#CA5010",
  yellow: "#DCC114",
  purple: "#854085",
  "cool-grey": "#737373",
  "dusty-grey": "#867365",
};

export default accentsConfig;
